import type { IntegrationProvider } from './types';

const slackProvider: IntegrationProvider = {
  key: 'slack',
  label: 'Slack',
  supportedObjects: ['conversation_messages'],
  activatableObjects: ['conversation_messages'],
  capabilities: {
    supportsFieldMapping: false,
    supportsRoleMapping: false,
    supportsRelationshipMapping: false,
    supportsWriteback: false,
  },
  flowKeys: {
    firstSync: {},
    receive: {},
    send: {},
  },
};

export default slackProvider;
